import FormItem from "@components/formItem";
import { PaymentContentWrapper } from "@pages/profile-v2/pages/withdraw/baseItems.js";
import React from "react";
import {
	Box,
	BoxTitle,
	Content,
	ContentTitle,
	StakeFieldWrapper,
	StakeInput,
} from "../baseItems.js";
import Base from "./base";

export default class AnindaCreditCard extends Base {
	getStep1(translate) {
		return (
			<Content>
				<ContentTitle data-testid="step-deposit-amount-title">{translate("Payment_Stake")}</ContentTitle>
				<PaymentContentWrapper>
					<div>{this.getCurrencyField(translate)}</div>
					<div>
						<StakeFieldWrapper>
							<div className="stake-field">{this.getStakeField()}</div>
							<div className="min-max-field">{this.renderMinMax()}</div>
						</StakeFieldWrapper>
					</div>
				</PaymentContentWrapper>
				<FormItem onRegister={() => this.registerField({ name: "playerIdentityNumber" })}>
					<Box>
						<BoxTitle>{translate("Identity Number")}</BoxTitle>
						<StakeInput
							data-testid="input-deposit-identity-number"
							autoFocus={false}
							placeholder={translate("Identity Number")}
							onChange={this.onEnterValue.bind(this, "playerIdentityNumber")}
							onLoad={() => this.registerField({ name: "playerIdentityNumber" })}
						/>
					</Box>
				</FormItem>
			</Content>
		);
	}

	makeExternalPayment(newStep) {
		const { playerIdentityNumber, stake, selectedCurrency } = this.state;
		this.props.externalFunc.depositAnindaCreditCard(
			{
				provider: "anindaIntegration",
				amount: Number(stake),
				currency: selectedCurrency,
				method: "CreditCard",
				playerIdentityNumber: playerIdentityNumber,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		const { playerIdentityNumber, stake, selectedCurrency } = this.state;
		this.props.externalFunc.depositAnindaCreditCard(
			{
				provider: "anindaIntegration",
				amount: Number(stake),
				currency: selectedCurrency,
				method: "CreditCard",
				playerIdentityNumber: playerIdentityNumber,
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}
}
